// extracted by mini-css-extract-plugin
export default {"buttons":"TaskForm_buttons__vGvHp"};